module.exports = __webpack_public_path__ + "static/img/login_bg@2x.9faa0aaa.png";